import { FC } from 'react';

import { IDSNavigationProps, MobileNavMenu, DesktopNavMenu } from '.';

const IDSNavigation: FC<IDSNavigationProps> = ({
  isMenuOpen,
  tabs,
  onMobileMenuItemClick,
}) => {
  return (
    <>
      {isMenuOpen ? (
        <MobileNavMenu
          tabs={tabs}
          isMenuOpen={isMenuOpen}
          onMobileMenuItemClick={onMobileMenuItemClick}
        />
      ) : (
        <DesktopNavMenu tabs={tabs} />
      )}
    </>
  );
};

export default IDSNavigation;
